<template>
  <div>
    <div class="JY-contactUs JY-about-banner" >
      <div class="container">
        <div class="row">
          <div class="col-sm-12 mt-4 mb-2 text-center">
            <div class="JY-bggray">
              <h2 class=" JY-partner">最新货源</h2>
              <h4>Freight Info</h4>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section style="margin-bottom:60px;">
      <div class="container">
        <div class="row">
          <el-table style="width: 100%"
                  :data="tableData"
                  v-loading.body="tableLoading"
                  element-loading-text="加载中..."
                  stripe border fit highlight-current-row>
            <el-table-column sortable prop="beginAddress" label="发货地址" align="left"></el-table-column>
            <el-table-column prop="endAddress" label="收货地址" align="left"></el-table-column>
            <el-table-column prop="cargoInfo" label="货源信息" align="center"></el-table-column>
            <el-table-column prop="contacts" label="联系人" align="center"></el-table-column>
            <el-table-column prop="contactInfo" label="联系方式" align="center"></el-table-column>
            <el-table-column prop="pulishTime" label="发布时间" align="center"></el-table-column>
          </el-table>

          <table style="width: 100%;margin-top: 15px;">
            <tr>
              <td align="right" width="80%">
                <el-pagination align="right" background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="tablePage.current"
                  :page-sizes="pageSizes"
                  :page-size="tablePage.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="tablePage.total">
                </el-pagination>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </section>
    <div style="font-size: 16px;margin-left: 390px;margin-bottom: 50px;">
      注册为嘉盈吉运平台承运人，即可查看更多货源信息，<a href="javascript:;" @click="goToRegister()">点这里注册新用户</a>
    </div>
  </div>
</template>

<script>

export default {
  components: {

  },
  data() {
    return {
      tableLoading: false,
      tableData: [],
      pageSizes:[10,20,50],
      tablePage: {
        current: null,
        pages: null,
        size: null,
        total: null
      },

    };
  },
  mounted(){
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.tableData=[
        {"beginAddress":"新疆维吾尔自治区库尔勒市","endAddress":"新疆维吾尔自治区喀什地区叶城县","cargoInfo":"饲料","contacts":"刘**","contactInfo":"186****8396","pulishTime":"2023/03/25 10:35"},
        {"beginAddress":"内蒙古自治区巴彦淖尔市乌拉特中旗","endAddress":"内蒙古自治区包头市石拐矿区	","cargoInfo":"建材","contacts":"赵**","contactInfo":"159****1545","pulishTime":"2023/03/27 8:50"},
        {"beginAddress":"内蒙古自治区巴彦淖尔市乌拉特中旗","endAddress":"内蒙古自治区巴彦淖尔市五原县","cargoInfo":"	建材","contacts":"赵**","contactInfo":"159****1545","pulishTime":"2023/03/26 17:35"},
        {"beginAddress":"江苏省南通市","endAddress":"内蒙古自治区巴彦淖尔市乌拉特中旗","cargoInfo":"饲料","contacts":"韩**","contactInfo":"132****8786","pulishTime":"2023/03/25 15:19"},
        {"beginAddress":"天津市宁河县","endAddress":"内蒙古自治区巴彦淖尔市乌拉特中旗","cargoInfo":"建材","contacts":"杨**","contactInfo":"182****7903","pulishTime":"2023/03/22 14:53"},
        {"beginAddress":"江苏省苏州市常熟市","endAddress":"内蒙古自治区巴彦淖尔市乌拉特中旗","cargoInfo":"	建材","contacts":"杨**","contactInfo":"182****7903","pulishTime":"2023/03/21 14:07"},
        {"beginAddress":"河北省邯郸市广平县","endAddress":"内蒙古自治区巴彦淖尔市乌拉特中旗","cargoInfo":"饲料","contacts":"周**","contactInfo":"136****9453","pulishTime":"2023/03/20 13:25"},
        {"beginAddress":"新疆维吾尔自治区喀什地区疏勒县","endAddress":"浙江省杭州市萧山区","cargoInfo":"建材","contacts":"刘**","contactInfo":"186****8396","pulishTime":"2023/03/17 13:18"},
        {"beginAddress":"新疆维吾尔自治区喀什地区疏勒县","endAddress":"广东省佛山市禅城区","cargoInfo":"	建材","contacts":"魏**","contactInfo":"189****6812","pulishTime":"2023/03/15 10:30"},
      ]
      this.tablePage.current=1
      this.tablePage.pages=1
      this.tablePage.size=10
      this.tablePage.total=9
    },
    resetSearchForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleSizeChange(val) {
      this.tablePage.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.tablePage.current = val
      this.fetchData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    goToRegister(){
      this.$router.push("/register");
    },

  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/FreightInfo.vue